export enum ECategoryRole {
  CommissionMatrixType = 'commissionMatrixType',
  TransactionType = 'transactionType'
}

export enum ECategoryType {
  Tagger = 'tagger',
}
